export default __webpack_public_path__ + "static/media/beraksi-phone1.6225c8b3.png";